import { PhysicalProductInterface } from '@systemeio/types'
import { DEFAULT_PRODUCTS_API, PRODUCTS_API } from 'modules/products/api/product-api'
import { ProductApiInterface } from 'modules/products/types/product-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from '@systemeio/util'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useProducts({ limit, pagination }: SwrPaginationInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ProductApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: products, mutate } = useControlledSwr(
    () => [
      `${PRODUCTS_API}/list?${getPaginationQueryString({
        pagination,
        limit,
      })}`,
      RequestModuleEnum.PhysicalProducts,
    ],
    fetcher,
    undefined,
    !!user,
  )

  const { data: counter } = useControlledSwr<CountInterface>(
    () => [`${PRODUCTS_API}/count`, RequestModuleEnum.PhysicalProducts],
    baseFetcher,
    undefined,
    !!user,
  )

  return { products, mutate, counter }
}

export function useProduct(id?: number) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, PhysicalProductInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr<PhysicalProductInterface>(() => {
    if (user && id) {
      return [`${PRODUCTS_API}/${id}`, RequestModuleEnum.PhysicalProducts]
    }
    return null
  }, fetcher)
}

export function useProductDefaultValues() {
  const { user } = useUser()

  return useSWR<Pick<PhysicalProductInterface, 'currency' | 'tax'>>(() => {
    if (user) {
      return `${DEFAULT_PRODUCTS_API}`
    }
    return null
  }, baseFetcher)
}
